var _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeJournaux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: 800,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "journauxBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#076a91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098bcc"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#journauxBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 60,
    r: 160
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 400,
    r: 120
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(285 140)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 220,
    height: 150,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 47 h95",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 75,
    width: 72,
    height: 56,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 83 h86 M122 105 h86 M122 127 h58 M32 153 h176"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeJournaux);
export default __webpack_public_path__ + "static/media/home-journaux.ac70f06e7b039a066c65a1b9f52947bc.svg";
export { ForwardRef as ReactComponent };